import React, { useEffect, useState } from "react";
import cx from "classnames";
import _ from "lodash";
import type { Asset } from "src/types/assets";
import Thumbnail from "src/components/thumbnail";
import styles from "./icon.module.scss";
import Tooltip from "src/components/tooltip";
import Badge from "src/components/badge";

interface AssetProps {
  asset: Asset;
  view?: string;
  isEditStream?: boolean;
  hoveredEntity?: string;
  isAssetSelected?: (asset: Asset) => boolean;
}

const AssetIcon: React.FC<AssetProps> = ({ asset, view, isEditStream, hoveredEntity, isAssetSelected }) => {

  const internal = !_.get(asset, 'settings.share', false);

  const isNewAsset = () => {
    const currentTime = Date.now();
    const contentModifiedDate = Number(asset.contentModifiedDate) || 0;
    const lastUpdatedDuration = 14 * 24 * 60 * 60 * 1000;

    return (currentTime - contentModifiedDate) < (lastUpdatedDuration);
  }

    return (
      <div className={cx(styles.container, view && styles[view], {
        [styles.hoveredContainer]: hoveredEntity ? asset.id === hoveredEntity : false,
      })}>

      {isNewAsset() && (<Badge className={styles.badge} />)}

        <div className={cx(styles.iconWrapper, view && styles[view], {
          [styles[`editStream-${view}`]]: isEditStream,
          [styles.selectedAsset]: isAssetSelected && isAssetSelected(asset)
        })}>

        {internal && !isEditStream && (<div className={styles.indicators}>
          <Tooltip content="Internal use only" placement="top">
            <i className="paperflite-lock" />
          </Tooltip>
          </div>)}
          <div className={styles.radioWrapper}>
            <i className={cx({
              "paperflite-radio-button-unselected": isAssetSelected && !isAssetSelected(asset),
              "fa-solid fa-check-circle": isAssetSelected && isAssetSelected(asset)
            })}></i>
          </div>
          
          <Thumbnail
          media={asset.icon}
          width={600}
          className={cx(styles.thumbnail, view && styles[view])}
          alt=""
          defaultImage="/images/assets/default_asset.jpg"
        />
        {view === "card" && (
          <span className={styles.assetTypeWrapper}>
            <span className={styles.assetType}>{_.get(asset, "type")}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default AssetIcon;
